import React from 'react';
import {
  FullWidthContainer,
  Header,
  HeaderContainer,
  HeaderTitle,
} from './LoginContainerHeader.styles';

interface Props {
  hideMenusWhenSmall?: boolean;
  logoComponent: React.ReactNode;
  title?: string;
}

export const LoginHeader = ({
  logoComponent,
  hideMenusWhenSmall,
  title,
}: Props) => {
  return (
    <FullWidthContainer isHidden={hideMenusWhenSmall}>
      <Header>
        <HeaderContainer>
          {logoComponent}

          {title && <HeaderTitle>{title}</HeaderTitle>}
        </HeaderContainer>
      </Header>
    </FullWidthContainer>
  );
};

export default LoginHeader;
